import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { CompanySearchSelect, BranchSearchSelect, DepositorSearchSelect } from '../SearchSelects';

const DepositsFilterForm = ({ fields, onSubmit }) => {
  const [formData, setFormData] = useState({});
  const [previousCompanyId, setPreviousCompanyId] = useState('');

  const handleInputChange = (name, valueOrEvent) => {
    // Handle both direct values and event objects
    let actualValue;
    if (valueOrEvent && typeof valueOrEvent === 'object' && valueOrEvent.target) {
      // It's an event object
      actualValue = valueOrEvent.target.value;
    } else {
      // It's a direct value
      actualValue = valueOrEvent;
    }

    setFormData(prev => {
      const newData = {
        ...prev,
        [name]: actualValue
      };
      
      // Clear branchId only when companyId actually changes to a different value
      if (name === 'companyId') {
        if (previousCompanyId && previousCompanyId !== actualValue) {
          newData.branchId = '';
        }
        setPreviousCompanyId(actualValue);
      }
      
      console.log('newData', newData);
      return newData;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleReset = () => {
    setFormData({});
    setPreviousCompanyId('');
    onSubmit({});
  };

  const renderField = (field) => {
    const { name, label, type, options = [], placeholder, required = false, render } = field;
    const value = formData[name] || '';

    // Custom render function for custom field types
    if (type === 'custom' && typeof render === 'function') {
      return (
        <Form.Group key={name} className="mb-3">
          {render({
            value,
            onChange: (val) => handleInputChange(name, val),
            name,
            label,
            placeholder,
            required
          })}
        </Form.Group>
      );
    }

    switch (type) {
      case 'branchSearchSelect':
        return (
          <Form.Group key={name} className="mb-3">
            <BranchSearchSelect
              key={`branch-${formData.companyId || 'no-company'}`}
              value={value}
              onChange={(valueOrEvent) => handleInputChange(name, valueOrEvent)}
              name={name}
              label={label}
              companyId={formData.companyId || ''}
              placeholder={placeholder || `Search and select ${label}...`}
              required={required}
              allowClear={true}
              showLabel={true}
            />
          </Form.Group>
        );

      case 'companySearchSelect':
        return (
          <Form.Group key={name} className="mb-3">
            <CompanySearchSelect
              value={value}
              onChange={(valueOrEvent) => handleInputChange(name, valueOrEvent)}
              name={name}
              label={label}
              placeholder={placeholder || `Search and select ${label}...`}
              required={required}
              allowClear={true}
              showLabel={true}
            />
          </Form.Group>
        );

      case 'depositorSearchSelect':
        return (
          <Form.Group key={name} className="mb-3">
            <DepositorSearchSelect
              key={`depositor-${formData.branchId || 'no-branch'}`}
              value={value}
              onChange={(valueOrEvent) => handleInputChange(name, valueOrEvent)}
              name={name}
              label={label}
              branchId={formData.branchId || ''}
              placeholder={placeholder || `Search and select ${label}...`}
              required={required}
              allowClear={true}
              showLabel={true}
            />
          </Form.Group>
        );

      case 'select':
        return (
          <Form.Group key={name} className="mb-3">
            <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
            <Form.Select
              className='form-control'
              value={value}
              onChange={(e) => handleInputChange(name, e.target.value)}
            >
              <option value="">Select {label}</option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        );

      case 'date':
        return (
          <Form.Group key={name} className="mb-3">
            <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
            <Form.Control
              type="date"
              value={value}
              onChange={(e) => handleInputChange(name, e.target.value)}
            />
          </Form.Group>
        );

      case 'number':
        return (
          <Form.Group key={name} className="mb-3">
            <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
            <Form.Control
              type="number"
              placeholder={placeholder || `Enter ${label}`}
              value={value}
              onChange={(e) => handleInputChange(name, e.target.value)}
            />
          </Form.Group>
        );

      case 'email':
        return (
          <Form.Group key={name} className="mb-3">
            <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
            <Form.Control
              type="email"
              placeholder={placeholder || `Enter ${label}`}
              value={value}
              onChange={(e) => handleInputChange(name, e.target.value)}
            />
          </Form.Group>
        );

      default: // text
        return (
          <Form.Group key={name} className="mb-3">
            <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
            <Form.Control
              type="text"
              placeholder={placeholder || `Enter ${label}`}
              value={value}
              onChange={(e) => handleInputChange(name, e.target.value)}
            />
          </Form.Group>
        );
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        {fields.map((field) => (
          <Col key={field.name} md={4} lg={3}>
            {renderField(field)}
          </Col>
        ))}
      </Row>
      <Row>
        <Col md={12} className='align-items-center text-center'>
          <div className="d-flex gap-2 justify-content-center w-full">
            <Button type="submit" variant="primary">
              Apply Filters
            </Button>
            <Button type="button" variant="secondary" onClick={handleReset}>
              Reset
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default DepositsFilterForm;